import ReqClient from './request.class'

// 添加广告组-批量
export async function addCampaignBatch(data) {
  const Req = new ReqClient({
    url: '/api/baidu/campaign/batchAdd',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 百度批量新增、复制计划
 * @param {*} data
 * @return {*}
 */
export async function addBaiduBatchTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addBaiduBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 百度批量失败修改计划
 * @param {*} data
 * @return {*}
 */
export async function updateBaiDuBatchTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateBaiDuBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
